module.exports = __webpack_public_path__ + "static/media/user-icon-white.e225a415.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-icon-white.svg
// module id = 1017
// module chunks = 0